<template>
  <div class="home xlbox">
     <!-- :style="{ height: pageHeight + 'px' }" -->
    <van-nav-bar
      fixed
      title="负荷曲线"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="">
      <div class="titfh" v-show="isShow">
        <p >电压趋势</p>
        <ul>
          <li :class="selectindex==Item.type? 'on' : ''" v-for="(Item, index) in selectList" :key="index" @click="select(Item.type)">
            <span>{{Item.lable}}</span>
          </li>
        </ul>
      </div>
      <div class="lengthtip" v-show="isShow">
        <p><span>{{defaultTime1}}</span> <span style="text-align: right;">{{this.elepoId}}</span></p>
        <ul>
          <li v-for="(Item, index) in item1" :key="index">
            <i :style="{background:Item.color}"></i>
            <span>{{Item.seriesName}}</span>
            <p>{{Item.data[1]}}V</p>
          </li>
        </ul>
      </div>
      <div class="chart" id="chart1" :style="{ height: pageHeight/2-120 + 'px' }" style="background:#fff;" v-show="isShow"></div>
      <div class="titfh">
        <p>电流趋势</p>
        <ul v-show="!isShow">
          <li :class="selectindex==Item.type? 'on' : ''" v-for="(Item, index) in selectList" :key="index" @click="select(Item.type)">
            <span>{{Item.lable}}</span>
          </li>
        </ul>
      </div>
      <div class="lengthtip">
        <p><span>{{defaultTime2}}</span> <span style="text-align: right;">{{this.elepoId}}</span></p>
        <ul>
          <li v-for="(Item, index) in item2" :key="index">
            <i  :style="{background:Item.color}"></i>
            <span>{{Item.seriesName}}</span>
            <p>{{Item.data[1]}}A</p>
          </li>
        </ul>
      </div>
      <div class="chart" id="chart2" :style="{ height: !isShow?(pageHeight/2 + 'px'): (pageHeight/2-120 + 'px')}" style="background:#fff;"></div>
    </div>
  </div>
</template>

<script>
import myMixinFHQX from '@/utils/minxinsFHQX.js'
import Vue from 'vue'
import {
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Icon,
  Collapse,
  CollapseItem,
  Toast
} from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Icon,
  Collapse,
  CollapseItem,
  Toast
)

export default {
  name: 'FHQXPage',
  mixins: [myMixinFHQX], // 引入混入
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Toast.name]: Toast
  },
  data () {
    return {
      isShow:false,//是否显示电压趋势
      pageHeight: window.innerHeight - 46,
      mlineId: '', // 线路id
      elepoId: '',
      selectindex: 1, // 默认选中日
      type: 1, // 时间 1日 2周 3月
      defaultTime1: '', // 曲线默认显示时间
      defaultTime2: '', // 曲线默认显示时间
      item1: '', // 点击曲线的提示
      item2: '', // 点击曲线的提示
      // aloadcurArr: [], // A相电流
      // bloadcurArr: [], // B相电流
      // cloadcurArr: [], // C相电流
      // aBavolArr: [], // A相电压
      // bBavolArr: [], // B相电压
      // cBavolArr: [], // C相电压
      listData: {}, // 接口返回数据
      selectList: [
        {
          lable: '日',
          type: 1
        },
        {
          lable: '周',
          type: 2
        },
        {
          lable: '月',
          type: 3
        }

      ]
    }
  },
  created () {
    // console.log('created')
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    //this.isShow=this.$route.query.isType==1?false:true
    this.getFHQXList()
  },
  activated () {
    // console.log('activated')
    // 如果要在每次进入页面的时候获取最新的数据，需要在activated阶段获取数据，承担原来created钩子中获取数据的任务。
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    //this.isShow=this.$route.query.isType==1?false:true
    this.getFHQXList()
  },
  mounted () {
    // console.log('mounted')
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1) // 返回上一页面
    },
    select (type) {
      // 切换日月周
      if (type === 1) {
        // 点击的日
        this.selectindex = 1
        this.type = 1
        // this.getFHQXList()
      } else if (type === 2) {
        // 点击的周
        this.selectindex = 2
        this.type = 2
        // this.getFHQXList()
      } else {
        // 点击的月
        this.selectindex = 3
        this.type = 3
        // this.getFHQXList()
      }
      this.getFHQXList()
    },
    getFHQXList () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true, // 是否禁止背景点击
        loadingType: 'spinner',
        duration: 20000
      })
      this.util.post('/getFHQX', {
        mlineId: this.mlineId, // 线路id
        elepoId: this.elepoId, // 杆塔id
        type: this.type // 时间 1日 2周 3月
      }).then(({ data }) => {
        //console.log(data)
        if (data.code === 200) {
          // currentPage: 1, // 当前页
          // pagesize: 20, // 每页显示条数
          this.listData = data.data
          // console.log(this.listData)
          this.defaultTime1 = data.data.defaultTime
          this.defaultTime2 = data.data.defaultTime
          // this.aloadcurArr = data.data.aloadcurArr // A相电流
          // this.bloadcurArr = data.data.bloadcurArr // B相电流
          // this.cloadcurArr = data.data.cloadcurArr // C相电流
          // this.aBavolArr = data.data.aBavolArr // A相电压
          // this.bBavolArr = data.data.bBavolArr // B相电压
          // this.cBavolArr = data.data.cBavolArr // C相电压
          this.$nextTick(() => {
            this.drawLine_aa()
            this.drawLine_bb()
            Toast.clear()// 手动清除 Toast
          })
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }

  },
  computed: {}
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar{
  background: linear-gradient(227deg, #06C8B5 0%, #007CF8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
.home{
  margin-top: 46px;
  background: #fff;
}

</style>
